import React from "react";
import ReactDOM from "react-dom/client";
import Generator from "./Generator";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./index.css";
import Resizer from "./Resize";
import App from "./App";

const BrowserRouter = createBrowserRouter([
  {
    path: "/generator",
    element: <Generator />,
  },
  {
    path: "/resizer",
    element: <Resizer />,
  },
  {
    path: "/",
    element: <App />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={BrowserRouter} />
  </React.StrictMode>
);
